module.exports = __webpack_public_path__ + "static/media/webd1.5c580131.jpg";